import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hairdresserActions } from '../../_actions';
import dateFormat from 'dateformat';
import PhoneInput from 'react-phone-number-input';
import BirthdayPicker from './BirthdayPicker';
import SlidePanel from '../shared/SlidePanel';
import toast from '../shared/Toast';
import './AddClientPanel.css';

class AddClientPanel extends Component {
  constructor(props) {
    super(props);
    // Optional details to start from (Bailey booking someone new).
    const initial = props.initial || {};
    this.state = {
      saving: false,
      first_name: initial.first_name || '',
      last_name: initial.last_name || '',
      email: initial.email || '',
      phoneNumber: initial.phoneNumber || '',
      note: '',
      dob: '',
      fNameError: '',
      lNameError: '',
      emailError: '',
      error: '',
      showClientExistsModal: false,
      existingClient: null,
      ownerInfo: null,
      showBirthdayPicker: false,
      // Marketing consent is OFF until the client agrees (UK GDPR: consent
      // must be a clear affirmative action, never pre-ticked)
      emailMarketingConsent: false,
      smsMarketingConsent: false,
    };
    this.dobAnchorRef = React.createRef();
    this.slidePanelRef = React.createRef();
  }

  onChanged = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.name === 'first_name') {
      this.setState({ fNameError: '' });
    }
    if (e.target.name === 'last_name') {
      this.setState({ lNameError: '' });
    }
    if (e.target.name === 'email') {
      this.setState({ emailError: e.target.value !== '' && !this.validateEmail(e.target.value) ? 'Please enter a valid email address' : '' });
    }
  }

  handlePhoneChange = (val) => {
    this.setState({ phoneNumber: val || '' });
  }

  selectDob = (date) => {
    this.setState({ dob: date, showBirthdayPicker: false });
  }

  validateEmail(email) {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(email);
  }

  // Who will see the note typed here (notes follow the book): an SE's own
  // book is theirs alone unless they share their clients; everyone else
  // writes in the salon's book. Unknown sharing → say nothing rather than
  // promise privacy we can't vouch for.
  noteCaption() {
    const hd = (this.props.user && this.props.user.userInfo && this.props.user.userInfo.hairdresser) || null;
    if (!hd) return '';
    const owner = Number(hd.isSalonOwner) === 1 || Number(hd.isSalonOwner) === 2;
    const se = !owner && Number(hd.employmentTypeId) === 2;
    const biz = ((hd.salon && hd.salon.salonName) || '').trim();
    const team = biz ? `the ${biz} team` : 'the team';
    if (!se) return `${biz ? `${biz} notes` : 'Team notes'} — visible to ${team}`;
    if (hd.clientShare === undefined || hd.clientShare === null) return '';
    return Number(hd.clientShare) === 1 ? `Visible to you and ${team}` : '🔒 Only you can see this';
  }

  addClient = () => {
    const self = this;

    if (!this.state.first_name.trim()) {
      this.setState({ fNameError: 'Please enter first name' });
      return;
    }
    if (!this.state.last_name.trim()) {
      this.setState({ lNameError: 'Please enter last name' });
      return;
    }
    if (this.state.email !== '' && !this.validateEmail(this.state.email)) {
      this.setState({ emailError: 'Please enter a valid email address' });
      return;
    }

    const params = {
      hairdresserId: localStorage.getItem('userId'),
      name: this.state.first_name + ' ' + this.state.last_name,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      phoneNumber: this.state.phoneNumber,
      note: this.state.note,
      dob: this.state.dob ? dateFormat(this.state.dob, 'dd-mm-yyyy') : '',
      emailMarketingConsent: this.state.emailMarketingConsent,
      smsMarketingConsent: this.state.smsMarketingConsent,
    };

    self.setState({ saving: true, error: '' });

    self.props.dispatch(hairdresserActions.createClient(params))
      .then(function (response) {
        const responseData = response.data.responseData || response.data.data || response.data;

        if (response.data.errorCode) {
          if (response.data.errorCode === 51) {
            self.setState({ emailError: response.data.messages, saving: false });
          } else {
            self.setState({ error: response.data.messages, saving: false });
          }
        } else if (responseData && responseData.clientExists) {
          self.setState({
            showClientExistsModal: true,
            existingClient: responseData.existingClient,
            ownerInfo: responseData.ownerInfo,
            saving: false,
          });
        } else {
          // Notes follow the book: the client was already at the salon on
          // someone else's card. Nothing was overwritten — they're now in
          // this person's list, with what they typed kept on their own book.
          if (responseData && responseData.alreadyExisted) {
            toast.success(responseData.message || "This client was already at the salon, so they've been added to your client list");
          }
          if (self.props.onClientAdded) {
            // Pass the new client data with form fields as fallback
            const apiClient = responseData?.client || responseData?.result || responseData;
            const newClient = {
              _id: apiClient?._id || apiClient?.id || apiClient?.userId,
              name: apiClient?.name || params.name,
              email: apiClient?.email || params.email,
              phoneNumber: apiClient?.phoneNumber || params.phoneNumber,
            };
            self.props.onClientAdded(newClient);
          }
        }
      })
      .catch(function () {
        self.setState({
          error: 'An error occurred. Please try again.',
          saving: false,
        });
      });
  }

  handleViewClient = () => {
    const { existingClient } = this.state;
    if (existingClient && existingClient._id) {
      this.setState({ showClientExistsModal: false });
      if (this.slidePanelRef.current) {
        this.slidePanelRef.current.handleClose();
      }
      setTimeout(() => {
        if (this.props.history) this.props.history.push('/client/' + existingClient._id);
      }, 320);
    }
  }

  closeClientExistsModal = () => {
    this.setState({ showClientExistsModal: false, existingClient: null, ownerInfo: null });
  }

  renderClientExistsModal() {
    if (!this.state.showClientExistsModal) return null;
    const { existingClient, ownerInfo } = this.state;

    return (
      <div className="sp-confirm-overlay" onClick={this.closeClientExistsModal}>
        <div className="sp-confirm-card" onClick={e => e.stopPropagation()}>
          <div className="sp-confirm-icon sp-confirm-icon--warning">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h3 className="sp-confirm-title">Client Already Exists</h3>
          <p className="sp-confirm-text">A client with this email already exists.</p>
          {existingClient && (
            <div className="acp-confirm-client">
              <p><span className="acp-confirm-client-label">Name: </span>{existingClient.name || (existingClient.first_name || '') + ' ' + (existingClient.last_name || '')}</p>
              <p><span className="acp-confirm-client-label">Email: </span>{existingClient.email}</p>
              {existingClient.phoneNumber && (
                <p><span className="acp-confirm-client-label">Phone: </span>{existingClient.phoneNumber}</p>
              )}
              {ownerInfo && ownerInfo.type !== 'own' && (
                <p style={{ color: '#9ca3af', fontSize: 12, marginTop: 6 }}>Added by {ownerInfo.hairdresserName || ownerInfo.type}</p>
              )}
            </div>
          )}
          <div className="sp-confirm-actions">
            <button
              onClick={this.closeClientExistsModal}
              style={{ border: '1px solid #e5e5e5', background: '#fff', color: '#6b7280' }}
            >
              Cancel
            </button>
            <button
              onClick={this.handleViewClient}
              style={{ border: 'none', background: '#29282D', color: '#fff' }}
            >
              View Client
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const footer = (
      <>
        <button className="sp-btn-secondary" onClick={() => this.slidePanelRef.current?.handleClose()} type="button">
          Cancel
        </button>
        <button className="sp-btn-primary" onClick={this.addClient} disabled={this.state.saving} type="button">
          {this.state.saving ? 'Saving...' : 'Save'}
        </button>
      </>
    );

    return (
      <>
        <SlidePanel
          ref={this.slidePanelRef}
          title="New Client"
          onClose={this.props.onClose}
          footer={footer}
        >
          {this.state.error && (
            <div className="sp-general-error">{this.state.error}</div>
          )}

          <div className="sp-form">
            <div className="sp-row">
              <div className="sp-field">
                <label className="sp-label">First Name</label>
                <input
                  className="sp-input"
                  type="text"
                  name="first_name"
                  placeholder="First name"
                  value={this.state.first_name}
                  onChange={this.onChanged}
                  autoFocus
                />
                {this.state.fNameError && <p className="sp-error">{this.state.fNameError}</p>}
              </div>
              <div className="sp-field">
                <label className="sp-label">Surname</label>
                <input
                  className="sp-input"
                  type="text"
                  name="last_name"
                  placeholder="Surname"
                  value={this.state.last_name}
                  onChange={this.onChanged}
                />
                {this.state.lNameError && <p className="sp-error">{this.state.lNameError}</p>}
              </div>
            </div>

            <div className="sp-field">
              <label className="sp-label">Email</label>
              <input
                className="sp-input"
                type="email"
                name="email"
                placeholder="email@example.com"
                value={this.state.email}
                onChange={this.onChanged}
              />
              {this.state.emailError && <p className="sp-error">{this.state.emailError}</p>}
            </div>

            <div className="sp-field sp-phone-wrapper">
              <label className="sp-label">Mobile Number</label>
              <PhoneInput
                international={true}
                defaultCountry="GB"
                country="GB"
                placeholder="Phone number"
                value={this.state.phoneNumber}
                onChange={this.handlePhoneChange}
              />
            </div>

            <div className="sp-field">
              <label className="sp-label">Birthday</label>
              <button
                type="button"
                ref={this.dobAnchorRef}
                className="sp-input acp-dob-trigger"
                onClick={() => this.setState({ showBirthdayPicker: true })}
              >
                {this.state.dob ? dateFormat(this.state.dob, 'dd/mm/yyyy') : <span className="acp-dob-placeholder">DD/MM/YYYY</span>}
              </button>
              <BirthdayPicker
                open={this.state.showBirthdayPicker}
                selected={this.state.dob}
                onChange={this.selectDob}
                onClose={() => this.setState({ showBirthdayPicker: false })}
                anchorEl={this.dobAnchorRef.current}
              />
            </div>

            <div className="sp-field">
              <label className="sp-label">Notes</label>
              {this.noteCaption() && (
                <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 6px' }}>{this.noteCaption()}</p>
              )}
              <textarea
                className="sp-textarea"
                name="note"
                placeholder="Any notes about this client..."
                value={this.state.note}
                onChange={this.onChanged}
              />
            </div>

            {/* Marketing consent: prominent by design, defaults off, and the
                hint copy is the script to read to the client */}
            <div className="sp-field" style={{ border: '1.5px solid rgba(0,126,160,0.3)', borderRadius: 12, padding: '14px 16px', background: 'rgba(0,126,160,0.04)' }}>
              <label className="sp-label" style={{ marginBottom: 2 }}>Marketing permission</label>
              <p className="sp-hint" style={{ margin: '0 0 10px' }}>
                Ask your client: "Are you happy to receive offers and news from us by email or text?" They can change their mind at any time.
              </p>
              {[
                { key: 'emailMarketingConsent', label: 'Email marketing' },
                { key: 'smsMarketingConsent', label: 'SMS marketing' },
              ].map(({ key, label }) => (
                <div key={key} className="sp-toggle-row" style={{ marginTop: 6 }}>
                  <span className="sp-toggle-label" style={{ fontWeight: 600, color: '#29282D' }}>{label}</span>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={this.state[key]}
                    onClick={() => this.setState({ [key]: !this.state[key] })}
                    style={{
                      width: 44, height: 26, borderRadius: 100, border: 'none', cursor: 'pointer', padding: 2,
                      background: this.state[key] ? '#007EA0' : '#DEDEE2', transition: 'background 0.15s', flexShrink: 0
                    }}
                  >
                    <span style={{
                      display: 'block', width: 22, height: 22, borderRadius: '50%', background: '#fff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.25)', transition: 'transform 0.15s',
                      transform: this.state[key] ? 'translateX(18px)' : 'translateX(0)'
                    }} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </SlidePanel>
        {this.renderClientExistsModal()}
      </>
    );
  }
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(AddClientPanel);
